import { Container } from '@hover/blueprint';
import React, { useState } from 'react';
import Desktop from './Desktop';
import Header from './Header';
import Mobile from './Mobile';
import { IntersectBox } from '../../common';

const BetterSection: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<number>(0);
  const [isIntersected, setIsIntersected] = useState<boolean>(false);

  const setTab = (tabId: number) => {
    setCurrentTab(tabId);
    const elm = document.getElementById(`invited-by-contractor-sign`);
    if (elm) {
      const offset = elm.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: offset + tabId * 81 - 70,
      });
    }
  };

  const onInterSect = (entry: number) => {
    if (entry) {
      setIsIntersected(true);
    }
  };

  return (
    <IntersectBox
      justifyContent="center"
      w="100%"
      setSectionIntersect={onInterSect}
    >
      <Container
        maxW="1200px"
        centerContent
        mb={1000}
        px={{ base: 0, desktop: 500 }}
      >
        <Header />
        <Desktop
          isIntersected={isIntersected}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />
        <Mobile
          isIntersected={isIntersected}
          currentTab={currentTab}
          setCurrentTab={setTab}
        />
      </Container>
    </IntersectBox>
  );
};

export default BetterSection;
